global.$ = global.jQuery = require("jquery");

// import ModuleName from 'module-path';
// let libName = require('library-name');
// jQuery(function() {
// Toggle Menu - Toggle Menu Function
$("#toggle").on("click", function() {
  console.log("hi");
  $(this).toggleClass("active");
  $(".main-menu").toggleClass("open");
  $(".navbar-expand").toggleClass("navbar-open");
  $(".header-logo").toggleClass("invisible");
});

// Hamburger Menu - Remove the Hamburger menu Overlay after click
$("#main-menu li a").on("click", function() {
  console.log("bye");
  $(".main-menu").removeClass("open");
  $(".navbar-expand").removeClass("navbar-open");
  $("#toggle").removeClass("active");
  $(".header-logo").removeClass("invisible");
});
// });

// Header - Add Sticky Header Function.
jQuery(document).on("scroll", function() {
  var heroHeight = jQuery(".hero-header-section").height();
  if (!heroHeight) heroHeight = 154;

  if (jQuery(document).scrollTop() > heroHeight) {
    jQuery(".site-header").addClass("sticky-header");
  } else {
    jQuery(".site-header").removeClass("sticky-header");
  }
});

// Scroll to Section - Add Scroll to Section Function.
jQuery(document).ready(function() {
  jQuery(".scroll-to-section a").on("click", function(event) {
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;
      jQuery("html, body").animate(
        {
          scrollTop: jQuery(hash).offset().top,
        },
        800,
        function() {
          window.location.hash = hash;
        }
      );
    } // End if
  });
});

// Moments Slider Function
jQuery(document).ready(function() {
  jQuery(".moments-slider-carousel").owlCarousel({
    loop: true,
    margin: 0,
    items: 1,
    responsiveClass: true,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 10000,
    autoplayHoverPause: true,
  });
  jQuery(".owl-prev").html('<i class="fas fa-chevron-left"></i>');
  jQuery(".owl-next").html('<i class="fas fa-chevron-right"></i>');
});

jQuery(document).ready(function() {
  jQuery(".custom-search").click(function() {
    jQuery(".search-form").show();
  });
  jQuery(".btn-brand-alt").click(function() {
    jQuery(".search-form").hide();
  });
});

jQuery(window).scroll(function() {
  var scroll = jQuery(window).scrollTop();
  jQuery(".about-animated-increase img").css({
    width: 100 + scroll / 25 + "%",
  });
  jQuery(".about-animated-decrease img").css({
    width: 100 - scroll / 25 + "%",
  });
  jQuery(".about-animated-increase img").css({
    width: 100 + scroll / 25 + "%",
  });
  jQuery(".about-animated-increase2 img").css({
    width: 130 + scroll / 7 + "%",
  });
  jQuery(".about-animated-up").css({
    bottom: 38 + scroll / 15 + "%",
  });
});

//   jQuery(".city-tab-select").click(function() {
//    var open = jQuery(this).data("isopen");
//    if(open && jQuery(this).val() != '') {
//        window.location.href = jQuery(this).val()
//    }
//    jQuery(this).data("isopen", !open);
// });
jQuery(document).ready(function() {
  //When the page loads

  jQuery(".city-tab-select").change(function() {
    //Initialize "On Select Change" listener
    var val = jQuery(this).val(); //Get the value of the select
    jQuery("html, body").animate(
      {
        //Animate the page scroll
        scrollTop: jQuery("#" + val).offset().top, //scroll to div with the same ID as the selected value
      },
      2000
    ); //Animation length in MS: 2000 = 2 seconds
  });
});

jQuery(function() {
  jQuery("#grantselector").change(function() {
    jQuery(".colors").hide();
    jQuery("#" + jQuery(this).val()).show();
  });
});

jQuery(function() {
  //Plugin activation
  jQuery(window).enllax();
  //    jQuery('#some-id').enllax();
  //    jQuery('selector').enllax({
  //    type: 'background', // 'foreground'
  //    ratio: 0.5,
  //    direction: 'vertical' // 'horizontal'
  //   });
});

// jQuery(document).ready(function($) {
//    jQuery('.speaker-contact').hide();
//    jQuery('.contact-info').click(function() {
//       var target = jQuery(this).data("target");
//       if(!jQuery(target).is(':visible'))
//             jQuery(target).show();
//       else
//          jQuery(target).hide();
//    });
//  });

//Accordiun Function
jQuery(".accordion-title").click(function(e) {
  e.preventDefault();
  var $this = jQuery(this);
  jQuery(".accordion-title").removeClass("open-acc");
  $this.addClass("open-acc");
  if ($this.next().hasClass("show")) {
    $this.next().removeClass("show");
    $this.next().slideUp(350);
    jQuery(".accordion-title").removeClass("open-acc");
  } else {
    $this
      .parent()
      .parent()
      .find(".inner")
      .removeClass("show");
    $this
      .parent()
      .parent()
      .find(".inner")
      .slideUp(350);
    $this.next().toggleClass("show");
    $this.next().slideToggle(350);
  }
});

// jQuery(document).ready(function() {
// 	var showChar = 100;
// 	var ellipsestext = "...";
// 	var moretext = "Read More";
// 	var lesstext = "Read Less";
// 	jQuery('.staff-des').each(function() {
// 		var content = $(this).html();

// 		if(content.length > showChar) {

// 			var c = content.substr(0, showChar);
// 			var h = content.substr(showChar-1, content.length - showChar);

// 			var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';

// 			$(this).html(html);
// 		}

// 	});

// 	$(".morelink").click(function(){
// 		if($(this).hasClass("less")) {
// 			$(this).removeClass("less");
// 			$(this).html(moretext);
// 		} else {
// 			$(this).addClass("less");
// 			$(this).html(lesstext);
// 		}
// 		$(this).parent().prev().toggle();
// 		$(this).prev().toggle();
// 		return false;
// 	});
// });

var isMobile = {
  Android: function() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function() {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  },
};
/* If the device is ios show the Contact button */
if (isMobile.iOS()) {
  jQuery(".ios-only").css("display", "block");
}
if (isMobile.any()) {
  jQuery(".ios-only").css("display", "none");
}
